export const firebaseConfig = {
  apiKey: "AIzaSyDbSa-iHWZQV0UmJ6FvUuXk0I-9jomWcdw",
  authDomain: "my-junior-advisor.firebaseapp.com",
  projectId: "my-junior-advisor",
  storageBucket: "my-junior-advisor.appspot.com",
  messagingSenderId: "701895342743",
  appId: "1:701895342743:web:16c67a3397596ce36247d2",
  measurementId: "G-C3TGWB872Y"
};